import { Experiment } from 'types/experiments'

export enum ClientMode {
  Manager = 'manager'
}

interface CommandBase {
  readonly baseUrl: string
  readonly apiUrl: string
}

export interface ManagerCommand extends CommandBase {
  readonly mode: ClientMode.Manager
  readonly rootId: string
  readonly progressBarId: string
  readonly addToQuickCheckoutEndpointUrl: string
  readonly integratedQuickCheckoutLandingUrlTemplate: string
  readonly prescriptionCartEndpointUrl: string
  readonly erxCartIntermediateEndpointUrl: string
  readonly cartLandingUrl: string
  readonly addToCartBaseUrl: string
  readonly addToCartMethod: string
  readonly addToCartTokenParamName: string
  readonly scanbotKey: string
  readonly scanbotKeyHostNames: Array<string>
  readonly quickCheckout: boolean
  readonly substitution: boolean
  readonly apiCartUrl: string
  readonly apiUrlV5: string
  readonly apiExperimentsUrl: string
  readonly insuranceNumberVerificationEnabled: boolean
  readonly experiments: Array<Experiment>
  readonly tenant: string
}

export type Command = ManagerCommand
